export const OPEN_POI_LISTING_MENU = 'OPEN_POI_LISTING_MENU';
export const CLOSE_POI_LISTING_MENU = 'CLOSE_POI_LISTING_MENU';
export const ENABLE_FLY_TO = 'ENABLE_FLY_TO';
export const DISABLE_FLY_TO = 'DISABLE_FLY_TO';

export const openPoiListingMenu = () => {
  return {
    type : OPEN_POI_LISTING_MENU,
    open: true
  };
};

export const closePoiListingMenu = () => {
  return {
    type : CLOSE_POI_LISTING_MENU,
    open: false
  };
};

export const enableFlyTo = () => {
  return {
    type : ENABLE_FLY_TO,
    flyTo: true
  };
};

export const disableFlyTo = () => {
  return {
    type : DISABLE_FLY_TO,
    flyTo: false
  };
};
